import WelcomeToSession from "~/pages/default-apps/Home/components/WelcomeToSession";
import {Fragment} from "react";
import {Controller, useForm} from "react-hook-form";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import {DatePicker} from '~/components';

function Appointment(){
    const {
        register,
        handleSubmit,
        reset,
        control,
        formState: { errors }
    } = useForm();

    const onSubmitFrom = () => {

    }

    return (
        <Fragment>
            <WelcomeToSession screen="Appointment"/>
            <section>
                <div className="container-medium">
                    <div className="g-5 g-lg-5 row">
                        <div className="mb-5 mb-md-0 text-center text-md-start col-md-5 col-12"><h3 className="mb-3">Stay
                            connected</h3><p className="mb-5">Stay connected with BreakThrough Help Center. BreakThrough is
                            available for your necessities at all times.</p>
                            <div className="d-flex flex-column align-items-center align-items-md-start gap-4">
                                <div className="d-flex flex-column flex-md-row gap-2 align-items-center">
                                    <div className="icon-wrapper shadow-info">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24"
                                             fill="currentColor" className="text-primary fs-4 z-1 ms-2"
                                             data-bs-theme="light">
                                            <path
                                                d="M19.44,13c-.22,0-.45-.07-.67-.12a9.44,9.44,0,0,1-1.31-.39,2,2,0,0,0-2.48,1l-.22.45a12.18,12.18,0,0,1-2.66-2,12.18,12.18,0,0,1-2-2.66L10.52,9a2,2,0,0,0,1-2.48,10.33,10.33,0,0,1-.39-1.31c-.05-.22-.09-.45-.12-.68a3,3,0,0,0-3-2.49h-3a3,3,0,0,0-3,3.41A19,19,0,0,0,18.53,21.91l.38,0a3,3,0,0,0,2-.76,3,3,0,0,0,1-2.25v-3A3,3,0,0,0,19.44,13Zm.5,6a1,1,0,0,1-.34.75,1.05,1.05,0,0,1-.82.25A17,17,0,0,1,4.07,5.22a1.09,1.09,0,0,1,.25-.82,1,1,0,0,1,.75-.34h3a1,1,0,0,1,1,.79q.06.41.15.81a11.12,11.12,0,0,0,.46,1.55l-1.4.65a1,1,0,0,0-.49,1.33,14.49,14.49,0,0,0,7,7,1,1,0,0,0,.76,0,1,1,0,0,0,.57-.52l.62-1.4a13.69,13.69,0,0,0,1.58.46q.4.09.81.15a1,1,0,0,1,.79,1Z"></path>
                                        </svg>
                                    </div>
                                    <div className="flex-1 ms-3"><a href="tel:+8714067509" className="link-900">(949) 287-8439</a></div>
                                </div>
                                <div className="d-flex flex-column flex-md-row gap-2 align-items-center">
                                    <div className="icon-wrapper shadow-info">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24"
                                             fill="currentColor" className="text-primary z-1 ms-2" data-bs-theme="light">
                                            <path
                                                d="M19,4H5A3,3,0,0,0,2,7V17a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V7A3,3,0,0,0,19,4Zm-.41,2-5.88,5.88a1,1,0,0,1-1.42,0L5.41,6ZM20,17a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V7.41l5.88,5.88a3,3,0,0,0,4.24,0L20,7.41Z"></path>
                                        </svg>
                                    </div>
                                    <div className="flex-1 ms-3"><a className="fw-semibold text-body"
                                                                    href="mailto:paideia@breakthrough.chat">paideia@breakthrough.chat</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="text-center text-md-start col-md-7 col-12"><h3 className="mb-3">Drop us a line</h3>
                            <p className="mb-7">If you have any query or suggestion, we are open to learn from you. Let's
                                talk, reach us anytime.</p>
                            <form onSubmit={handleSubmit(onSubmitFrom)} id="formAppointment" className="d-flex flex-column gap-4">
                                <div className="row">
                                    <div className="col-sm-6 col-12">
                                        <input placeholder="Your Name"
                                               className="form-control"
                                               type="text"
                                               {...register("CustomerName", { required: "Your name is required." })}
                                        />
                                        {errors.CustomerName && (
                                            <span className="text-danger fs-9 fw-bold">{errors.CustomerName.message}</span>
                                        )}
                                    </div>
                                    <div className="col-sm-6 col-12">
                                        <input placeholder="Phone Number"
                                               className="form-control"
                                               type="text"
                                               {...register("PhoneNumber", {
                                                   required: "Phone number is required.",
                                                   validate: (value) => {
                                                       const phoneNumber = parsePhoneNumberFromString(value);
                                                       if (!phoneNumber) return "Invalid phone number format. Example: +1 415 555 2671";
                                                       if (!phoneNumber.isValid()) return "Phone number is not valid. Example: +84 912 345 678";
                                                       return true;
                                                   },
                                               })}
                                        />
                                        {errors.PhoneNumber && (
                                            <span className="text-danger fs-9 fw-bold">{errors.PhoneNumber.message}</span>
                                        )}
                                    </div>
                                    <div className="col-sm-6 col-12 mt-4">
                                        <input placeholder="Email"
                                               className="form-control"
                                               type="text"
                                               {...register("Email", {
                                                   required: "Email is required.",
                                                   pattern: {
                                                       value: /^\S+@\S+$/i,
                                                       message: "Invalid email format."
                                                   }
                                               })}
                                        />
                                        {errors.Email && (
                                            <span className="text-danger fs-9 fw-bold">{errors.Email.message}</span>
                                        )}
                                    </div>
                                    <div className="col-sm-6 col-12 mt-4">
                                        <Controller
                                            name="StartDate"
                                            control={control}
                                            rules={{
                                                required: "Please select an appointment date"
                                            }}
                                            render={({ field }) => (
                                                <DatePicker
                                                    value={field.value || []}
                                                    onChange={(dates) => {
                                                        field.onChange(dates)
                                                    }}
                                                    placeholder="Appointment date..."
                                                    options={{
                                                        time_24hr: true,
                                                        minuteIncrement: 5
                                                    }}
                                                    dateFormat="Y-m-d H:i"
                                                    enableTime={true}
                                                />
                                            )}
                                        />
                                        {errors.StartDate && (
                                            <span className="text-danger fs-9 fw-bold">{errors.StartDate.message}</span>
                                        )}
                                    </div>
                                </div>
                                <div>
                                    <input placeholder="Subject"
                                           required=""
                                           className="form-control"
                                           type="text"
                                           {...register("Subject", { required: "Subject is required." })}
                                    />
                                    {errors.Subject && (
                                        <span className="text-danger fs-9 fw-bold">{errors.Subject.message}</span>
                                    )}
                                </div>
                                <div>
                                    <textarea
                                        rows="6"
                                        name="Description"
                                        placeholder="Description"
                                        required=""
                                        className="form-control"
                                        {...register("Description", { required: "Description is required." })}
                                    >
                                    </textarea>
                                    {errors.Description && (
                                        <span className="text-danger fs-9 fw-bold">{errors.Description.message}</span>
                                    )}
                                </div>
                                <button type="submit" className="btn btn-bt-primary">Submit Appointment</button>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </Fragment>
    )
}

export default Appointment;